const configuredVersion = process.env.REACT_APP_BUILD_VERSION || '1.2.193';
export const BUILD_VERSION = configuredVersion.startsWith('v')
  ? configuredVersion
  : `v${configuredVersion}`;
